/**
 * 객체의 키와 벨류를 스왑한다.
 */
export const swap = (data) => {
    const swapData = {};
    Object.keys(data).forEach((key) => {
        swapData[data[key]] = key;
    });
    return swapData;
};
